import styled from 'styled-components'
import {
	WrapperBlock,
	themeObject,
	textModels,
	media,
	Breakpoints,
} from 'Pages/landings/newLandings/common/style'

export const Wrapper = styled(WrapperBlock)`
	color: ${themeObject.colors.grey[800]};
`
export const Title = styled.p`
	${textModels('heading', 'h2', '600')}
	margin-bottom: 40px;
`
export const Text = styled.p`
	${textModels('text', 'l', '400')}
	border-bottom: 1px solid ${themeObject.colors.grey[600]};
	flex-grow: 1;
	padding: 3px 0px 40px 0px;
	${media('padding-top: 6px;', Breakpoints.ms)}
	${media('padding-top: 8px;', Breakpoints.lx)}
	${media('padding-top: 12px;', Breakpoints.xl)}
`
export const Href = styled.a`
	text-decoration: underline solid ${themeObject.colors.brand[500]} 1px;
	color: ${themeObject.colors.brand[500]};
`
